// dayjsライブラリを使った日時処理
import dayjs from "dayjs";
import "dayjs/locale/ja";
import utc from 'dayjs/plugin/utc'
// 日本時間に変換する設定
dayjs.locale("ja");

export const createCalendar = month => {
  const firstDay = getMonth(month);
  const firstDayIndex = firstDay.day();

  return Array(42)
    .fill(0)
    .map((_, i) => {
      const diffFromFirstDay = i - firstDayIndex;
      const day = firstDay.add(diffFromFirstDay, "day");

      return day;
    });
};

// 当日かどうか判定
export const isSameDay = (d1, d2) => {
  const format = "YYYYMMDD";
  return d1.format(format) === d2.format(format);
};

// 今月かどうか判定
export const isSameMonth = (m1, m2) => {
  const format = "YYYYMM";
  return m1.format(format) === m2.format(format);
};

// 月の最初の日か判定
export const isFirstDay = day => day.date() === 1;

export const getMonth = ({ year, month }) => {
  return dayjs(`${year}-${month}`);
};

export const getNextMonth = month => {
  const day = getMonth(month).add(1, "month");
  return formatMonth(day);
};

export const getPreviousMonth = month => {
  const day = getMonth(month).add(-1, "month");
  return formatMonth(day);
};

export const formatMonth = day => ({
  month: day.month() + 1,
  year: day.year()
});

export const formatYearMonth = ({ year, month }) => {
  return `${year}年${month}月`;
};

// CourceItem開催日当日かどうか判定
// d2はDBにて日時生成＆取得しているので日本時間に変換しないように注意
export const isScheduleSameDay = (d1, d2) => {
  const format = "YYYYMMDD";
  const formatedD1 = d1.format(format);
  dayjs.extend(utc);
  const formatedD2 = dayjs.utc(d2).format(format);
  return formatedD1 === formatedD2;
};

// 引数はDBにて日時生成＆取得しているので日本時間に変換しないように注意
export const formatTime = (reservable_at) => {
  const format = "HH:mm";
  dayjs.extend(utc);
  return dayjs.utc(reservable_at).format(format);
}

export const isWeekSun = (d1) => {
  const result = d1.format('d') === '0';
  return result;
}

// JTZ(DB登録用)
export const formatDatetime = (dttime) => {
  const format = "YYYY-MM-DD HH:mm:ss";
  return dayjs(dttime).format(format);
}

// JTZ(表示用)
export const formatDatetimeDisplay = (dttime) => {
  const format = "YYYY年MM月DD日 HH時mm分 〜";
  return dayjs(dttime).format(format);
}

// UTCに変換(DB登録用)
export const formatUtcDatetime = (dttime) => {
  const format = "YYYY-MM-DD HH:mm:ss";
  dayjs.extend(utc);
  return dayjs.utc(dttime).format(format);
}

// UTCに変換(表示用)
export const formatUtcDatetimeDisplay = (dttime) => {
  const format = "YYYY年MM月DD日 HH時mm分 〜";
  dayjs.extend(utc);
  return dayjs.utc(dttime).format(format);
}